import DescriptioncourseModule from './containers/descriptioncourseModule'

export {default as DescriptioncourseModuleLayout} from './components/descriptioncourseModuleLayout'

export default DescriptioncourseModule
